import { t } from '../i18n.js';

/**
 * Per-house camera tiles — demo/offline placeholder only.
 * Product: independent NVR; App shows view + alarm link, not recording.
 */
export function renderCam(root, state) {
  const lang = state.lang;
  const cams = state.cameras || [];
  root.innerHTML = `
    <div class="view">
      <h2 class="view-title">${t(lang, 'cam')}</h2>
      <p class="meta" style="margin:0 0 10px;color:var(--muted);font-size:12px;">
        ${t(lang, 'camHint')}
      </p>
      <div class="cam-grid">
        ${cams.map((c) => camCard(c, lang)).join('') || emptyCam(lang)}
      </div>
    </div>
  `;
}

function emptyCam(lang) {
  return `<div class="card cam-card"><div class="cam-stage offline"><span>${t(lang, 'camNone')}</span></div></div>`;
}

function camCard(c, lang) {
  const title = lang === 'en' && c.nameEn ? c.nameEn : c.name;
  const online = !!c.online;
  const badge = online
    ? `<span class="badge on">LIVE</span>`
    : `<span class="badge off">${t(lang, 'camOffline')}</span>`;
  return `
    <div class="card cam-card" data-cam-id="${c.id}">
      <div class="cam-head">
        <h3>${escapeHtml(title)}</h3>
        ${badge}
      </div>
      <div class="cam-stage ${online ? '' : 'offline'}" role="img" aria-label="${escapeHtml(title)}">
        ${online
          ? `<div class="cam-live-stub"></div>`
          : `<div class="cam-offline-inner">
               <span class="cam-icon" aria-hidden="true">▣</span>
               <span>${t(lang, 'camDemoTile')}</span>
             </div>`}
      </div>
      <div class="meta">${escapeHtml(c.note || '')}</div>
    </div>
  `;
}

function escapeHtml(s) {
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
